import './StatusArrow.scss'

import React from 'react';

import Col from 'react-bootstrap/Col';

const StatusArrow = ({ active, name }) => {

  return (
    <Col className={(active ? 'active' : '') + ' arrow-column'}>
      <div>
        <div className={(active ? 'active' : '') + ' triangle-top-left'}> </div>
        <div className={(active ? 'active' : '') + ' triangle-bottom-left'}> </div>
        <div className={(active ? 'active' : '') + ' centre-block'}><p>{name}</p></div>
        <div className={(active ? 'active' : '') + ' triangle-right'}> </div>
      </div>
    </Col>
  )
}

export { StatusArrow };
